import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/reminder-send-volume")({
    beforeLoad: () => {
        throw redirect({ to: "/developer/reminder-send-volume", replace: true });
    },
});
